export const enum EBillingStatus {
  paid = 'paid',
  refused = 'refused',
  pending = 'pending',
  autorescueFail = 'autorescue_fail',
  autorescueCanceled = 'autorescue_canceled',
  waitingRefund = 'waitingRefund',
  canceled = 'canceled',
  renewalCanceled = 'renewal_canceled',
  trial = 'trial',
  fail = 'fail',
  rescuing = 'rescuing',
  refunded = 'refunded',
  authorized = 'authorized',
  trialCanceled = 'trial_canceled',
  trialEnded = 'trial_ended',
  fraud = 'fraud',
}

export enum ETransactionStatus {
  PAID = 'paid',
  INSUFFICIENT_BALANCE = 'insufficient_balance',
  REFUSED = 'refused',
  BLOCKED_CARD = 'blocked_card',
  EXPIRED_CARD = 'expired_card',
  INVALID_CARD_NUMBER = 'invalid_card_number',
  CANCELED = 'canceled',
  TRANSACTION_NOT_ALLOWED = 'transaction_not_allowed',
  RESCUING = 'rescuing',
  FILLING_ERROR = 'filling_error',
  SETTINGS_ERROR = 'settings_error',
  PROCESS_FAILED = 'process_failed',
  TRIAL = 'trial',
  REFUNDED = 'refunded',
  fraud = 'fraud',
}
export enum ESubscriptionStatus {
  paid = 'paid',
  refunded = 'refunded',
  rescuingFull = 'rescuing_full',
  rescuingFallback = 'rescuing_fallback',
  rescuingMonthly = 'rescuing_monthly',
  end = 'end',
  failedRenew = 'failed_renew',
  renewing = 'renewing',
  trial = 'trial',
  trialEnded = 'trial_ended',
  trialCanceled = 'trial_canceled',
  canceled = 'canceled',
  fraud = 'fraud',
}

export const enum EGateway {
  adyen = 1,
  pagarme = 2,
  googlePlay = 3,
  iTunes = 4,
  nupay = 5,
  pagaleve = 6,
}

export const enum EPaymentMethod {
  creditCard = 'credit_card',
  boleto = 'boleto',
  pix = 'pix',
  googlePlay = 'google_play',
  nupay = 'nupay',
  itunes = 'itunes',
}

export const enum ESubscriptionType {
  full = 'full',
  fallback = 'fallback',
  monthly = 'monthly',
  yearly = 'yearly',
}

export const BILLING_STATUS_LABEL: Record<EBillingStatus, string> = {
  [EBillingStatus.paid]: 'Pago',
  [EBillingStatus.refused]: 'Recusado',
  [EBillingStatus.pending]: 'Pendente',
  [EBillingStatus.authorized]: 'Autorizado',
  [EBillingStatus.autorescueCanceled]: 'Auto Rescue Cancelado',
  [EBillingStatus.autorescueFail]: 'Auto Rescue Falhou',
  [EBillingStatus.canceled]: 'Cancelado',
  [EBillingStatus.waitingRefund]: 'Aguardando Reembolso',
  [EBillingStatus.renewalCanceled]: 'Renovação Cancelada',
  [EBillingStatus.trial]: 'Trial',
  [EBillingStatus.trialCanceled]: 'Trial cancelado',
  [EBillingStatus.trialEnded]: 'Trial Finalizado',
  [EBillingStatus.fail]: 'Falhou',
  [EBillingStatus.rescuing]: 'Em Recuperação',
  [EBillingStatus.refunded]: 'Reembolsado',
  [EBillingStatus.fraud]: 'Fraude',
};

export const BILLING_STATUS_COLORS: Record<EBillingStatus, string> = {
  [EBillingStatus.paid]: 'green',
  [EBillingStatus.refused]: 'red',
  [EBillingStatus.pending]: 'gold',
  [EBillingStatus.authorized]: 'blue',
  [EBillingStatus.autorescueCanceled]: 'volcano',
  [EBillingStatus.autorescueFail]: 'volcano',
  [EBillingStatus.canceled]: 'purple',
  [EBillingStatus.waitingRefund]: 'gold',
  [EBillingStatus.renewalCanceled]: 'blue',
  [EBillingStatus.trial]: 'magenta',
  [EBillingStatus.trialCanceled]: 'red',
  [EBillingStatus.trialEnded]: 'magenta',
  [EBillingStatus.fail]: 'red',
  [EBillingStatus.rescuing]: 'orange',
  [EBillingStatus.refunded]: 'cyan',
  [EBillingStatus.fraud]: 'red',
};

export const SUBSCRIPTION_STATUS_LABEL: Record<ESubscriptionStatus, string> = {
  [ESubscriptionStatus.paid]: 'Pago',
  [ESubscriptionStatus.refunded]: 'Reembolsado',
  [ESubscriptionStatus.end]: 'Finalizado',
  [ESubscriptionStatus.rescuingFallback]: 'Em Recuperação Fallback',
  [ESubscriptionStatus.rescuingFull]: 'Em Recuperação Full',
  [ESubscriptionStatus.rescuingMonthly]: 'Em Recuperação Mensal',
  [ESubscriptionStatus.failedRenew]: 'Renovação Falhou',
  [ESubscriptionStatus.renewing]: 'Renovando',
  [ESubscriptionStatus.trial]: 'Trial',
  [ESubscriptionStatus.trialCanceled]: 'Trial Cancelado',
  [ESubscriptionStatus.trialEnded]: 'Trial Finalizado',
  [ESubscriptionStatus.canceled]: 'Cancelado',
  [ESubscriptionStatus.fraud]: 'Fraude',
};

export const SUBSCRIPTION_STATUS_COLORS: Record<ESubscriptionStatus, string> = {
  [ESubscriptionStatus.paid]: 'green',
  [ESubscriptionStatus.refunded]: 'cyan',
  [ESubscriptionStatus.end]: 'red',
  [ESubscriptionStatus.rescuingFallback]: 'gold',
  [ESubscriptionStatus.rescuingFull]: 'blue',
  [ESubscriptionStatus.rescuingMonthly]: 'magenta',
  [ESubscriptionStatus.failedRenew]: 'red',
  [ESubscriptionStatus.renewing]: 'magenta',
  [ESubscriptionStatus.trial]: 'magenta',
  [ESubscriptionStatus.trialCanceled]: 'red',
  [ESubscriptionStatus.trialEnded]: 'magenta',
  [ESubscriptionStatus.canceled]: 'purple',
  [ESubscriptionStatus.fraud]: 'red',
};

export const TRANSACTION_STATUS_LABEL: Record<ETransactionStatus, string> = {
  [ETransactionStatus.BLOCKED_CARD]: 'Cartão Bloqueado',
  [ETransactionStatus.CANCELED]: 'Cancelada',
  [ETransactionStatus.REFUSED]: 'Recusada',
  [ETransactionStatus.EXPIRED_CARD]: 'Cartão Expirado',
  [ETransactionStatus.PROCESS_FAILED]: 'Falha no processo',
  [ETransactionStatus.FILLING_ERROR]: 'Erro de Preenchimento',
  [ETransactionStatus.INSUFFICIENT_BALANCE]: 'Saldo Insuficiente',
  [ETransactionStatus.INVALID_CARD_NUMBER]: 'Numero do cartão invalido',
  [ETransactionStatus.PAID]: 'Pago',
  [ETransactionStatus.REFUNDED]: 'Reembolsado',
  [ETransactionStatus.RESCUING]: 'Em Recuperação',
  [ETransactionStatus.SETTINGS_ERROR]: 'Erro de configuração',
  [ETransactionStatus.TRANSACTION_NOT_ALLOWED]: 'Transação não autorizada',
  [ETransactionStatus.TRIAL]: 'Trial',
  [ETransactionStatus.fraud]: 'Fraude',
};

export type NonRedTransactionStatus =
  | ETransactionStatus.PAID
  | ETransactionStatus.REFUNDED
  | ETransactionStatus.RESCUING
  | ETransactionStatus.TRIAL;

export const TRANSACTION_STATUS_COLORS: Record<
  NonRedTransactionStatus,
  string | undefined
> = {
  [ETransactionStatus.PAID]: '#52C41A',
  [ETransactionStatus.REFUNDED]: '#2F54EB',
  [ETransactionStatus.RESCUING]: '#1890FF',
  [ETransactionStatus.TRIAL]: '#13C2C2',
};

export const GATEWAY_LABEL: Record<EGateway, string> = {
  [EGateway.adyen]: 'Adyen',
  [EGateway.googlePlay]: 'Google Play',
  [EGateway.iTunes]: 'iTunes',
  [EGateway.nupay]: 'NuPay',
  [EGateway.pagaleve]: 'Paga Leve',
  [EGateway.pagarme]: 'PagarMe',
};

export const SUBSCRIPTION_TYPE_LABEL: Record<ESubscriptionType, string> = {
  [ESubscriptionType.full]: 'Full',
  [ESubscriptionType.fallback]: 'Fallback',
  [ESubscriptionType.monthly]: 'Mensal',
  [ESubscriptionType.yearly]: 'Anual',
};

export const PAYMENT_METHOD_LABEL: Record<EPaymentMethod, string> = {
  [EPaymentMethod.boleto]: 'Boleto',
  [EPaymentMethod.creditCard]: 'Cartão de Crédito',
  [EPaymentMethod.googlePlay]: 'Google Play',
  [EPaymentMethod.nupay]: 'NuPay',
  [EPaymentMethod.pix]: 'Pix',
  [EPaymentMethod.itunes]: 'iTunes',
};
